module.exports = __webpack_public_path__ + "static/media/Sentret_gaussian2.3bfd18ef.png";